import { render, staticRenderFns } from "./LetterData.vue?vue&type=template&id=3ee1126d&scoped=true&"
import script from "./LetterData.vue?vue&type=script&lang=js&"
export * from "./LetterData.vue?vue&type=script&lang=js&"
import style0 from "./LetterData.vue?vue&type=style&index=0&id=3ee1126d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee1126d",
  null
  
)

export default component.exports